<template>
  <div class="map-container">
    <!-- 地图容器 -->
    <div id="map-container" style="width:100%;height:500px"></div>
    
    <!-- 导航按钮 -->
    <el-button type="primary" @click="handleNavigation" :disabled="!isNavigationAvailable">
      开始导航
    </el-button>
    
    <el-button type="link"  @click="toList" >返回列表</el-button>
    <div class="position-info">
      <p>我的位置：{{ currentPosition.latitude }}, {{ currentPosition.longitude }}</p>
      <p>商户位置：{{ merchantPosition.latitude }}, {{ merchantPosition.longitude }}</p>
      <p v-if="isDefaultPosition">注意：获取当前位置失败，使用了商户位置作为默认值</p>
      <p>导航URL：{{ navigationUrl }}</p>
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { Message } from 'element-ui';

export default {
  name: 'NavigationMap',
  data() {
    return {
      map: null,
      isNavigationAvailable: false,
      isDefaultPosition: false,
      navigationUrl: '',
      currentPosition: {
        latitude: '',
        longitude: '',
      },
      merchantPosition: {
        latitude: parseFloat(this.$route.params.lat),
        longitude: parseFloat(this.$route.params.lng),
      }
    };
  },
  async mounted() {
    try {
      // 配置安全密钥
      window._AMapSecurityConfig = {
        securityJsCode: '25b2d44b1598acf7a9e8d7f2ec05ef5d'
      };
      
      // 获取当前位置
      await this.getCurrentPosition();
      
      // 初始化地图
      await this.initAMap();
      
      this.isNavigationAvailable = true;
    } catch (error) {
      console.error('初始化失败:', error);
      Message.error('地图初始化失败，请稍后重试');
    }
  },
  methods: {
	toList(){
		this.$router.push('/businesslist')
	},
    /**
     * 获取当前位置坐标
     */
    async getCurrentPosition() {
      try {
        const coords = await this.fetchCurrentCoordinates();
        this.currentPosition = {
          latitude: coords.lat.toFixed(6),
          longitude: coords.lng.toFixed(6)
        };
        
        // 生成导航URL
        this.navigationUrl = this.generateNavigationUrl();
        Message.success('当前位置获取成功');
      } catch (error) {
        console.error('获取当前位置失败:', error);
        this.currentPosition = { ...this.merchantPosition };
        this.isDefaultPosition = true;
        Message.warning('无法获取当前位置，将使用商户位置作为默认值');
      }
    },
    
    isMobile() {
    	return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
    		.test(navigator.userAgent);
    },
    /**
     * 获取当前坐标
     */
    fetchCurrentCoordinates() {
				let defaultatLng = { lat: 39.9075, lng: 116.3881 }
				if (this.isMobile()) {
					return new Promise((resolve, reject) => {
						if (navigator.geolocation) {
							navigator.geolocation.getCurrentPosition(
								(position) => {
									resolve({
										lat: position.coords.latitude || defaultatLng.lat, // 默认值111
										lng: position.coords.longitude || defaultatLng.lng // 默认值222
									});
								},
								(error) => {
									Message.error('geolocation error')
									resolve(defaultatLng);
								}
							);
						} else {
							Message.error('不支持geolocation')
							resolve(defaultatLng);
						}
					});
				} else {
					return new Promise((resolve, reject) => {
						const geolocation = new BMap.Geolocation();
						if (geolocation) {
							geolocation.getCurrentPosition(
								r => {
									console.log(r)
									if (r) {
										resolve({
											lat: r.point.lat,
											lng: r.point.lng
										});
									} else {
										reject(new Error('定位失败: '));
									}
								}, {
									enableHighAccuracy: true
								}
							);
						} else {
							console.error('浏览器不支持 BMap.Geolocation');
							reject(new Error('浏览器不支持 BMap.Geolocation'));
						}
					});
				}
			},
    
    /**
     * 初始化高德地图
     */
    async initAMap() {
      try {
        await AMapLoader.load({
          key: '6e9332eba845e4c8858e76de36827592',
          version: '2.0',
          plugins: ['AMap.Geolocation', 'AMap.Marker', 'AMap.Driving']
        });
        
        this.initMap();
        this.addMerchantMarker();
      } catch (error) {
        console.error('地图加载失败:', error);
        throw new Error('地图加载失败');
      }
    },
    
    /**
     * 初始化地图实例
     */
    initMap() {
      this.map = new AMap.Map('map-container', {
        center: [this.merchantPosition.latitude, this.merchantPosition.longitude],
        zoom: 15,
        resizeEnable: true
      });
    },
    
    /**
     * 添加商户标记
     */
    addMerchantMarker() {
      new AMap.Marker({
        position: [this.merchantPosition.latitude, this.merchantPosition.longitude],
        map: this.map,
        title: '商户位置'
      });
    },
    
    /**
     * 生成导航URL
     */
    generateNavigationUrl() {
      return `https://uri.amap.com/navigation?from=${this.currentPosition.latitude},${this.currentPosition.longitude}&to=${this.merchantPosition.latitude},${this.merchantPosition.longitude}&mode=drive`;
    },
    
    /**
     * 处理导航按钮点击
     */
    handleNavigation() {
      if (this.navigationUrl) {
        window.open(this.navigationUrl, '_blank');
      } else {
        Message.error('导航URL生成失败');
      }
    }
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.position-info {
  margin-top: 15px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.position-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #666;
}
</style>
